export default "__VITE_ASSET__B59j7qv8__"